import React from "react";
import { Form } from "react-bootstrap";
import InfoTooltip from "@core/components/InfoTooltip";
import EntityScopePicker, {
    EntityScopePickerChange,
} from "@features/entity/components/EntityScopePicker";
import { INVITE_DESTINATION_HINT } from "@features/admin/invitations/constants/inviteModal";
import { getInviteDestinationChildScopes } from "@features/invitations/utils/getScopeFromParam";

export type InviteDestinationChange = EntityScopePickerChange;

interface InviteDestinationFieldProps {
    ownScopeValue: string;
    ownScopeRefId: number;
    ownLabel: string;
    /** Encoded destination value (SCOPE:id). */
    value: string;
    onChange: (next: InviteDestinationChange) => void;
    enabled?: boolean;
    isInvalid?: boolean;
    errorText?: string;
}

/**
 * Invite-to control: read-only at church; otherwise searchable grouped picker
 * (own level + districts and/or churches).
 */
const InviteDestinationField: React.FC<InviteDestinationFieldProps> = ({
    ownScopeValue,
    ownScopeRefId,
    ownLabel,
    value,
    onChange,
    enabled = true,
    isInvalid = false,
    errorText,
}) => {
    const childScopes = getInviteDestinationChildScopes(ownScopeValue);
    const readOnly = childScopes.length === 0;

    return (
        <Form.Group controlId="invTargetScope" data-testid="invite-entity-picker-field">
            <Form.Label>
                Invite to<span className="text-danger">*</span>
                {!readOnly && <InfoTooltip text={INVITE_DESTINATION_HINT} />}
            </Form.Label>
            <EntityScopePicker
                ownScopeValue={ownScopeValue}
                ownScopeRefId={ownScopeRefId}
                ownLabel={ownLabel}
                value={value}
                onChange={onChange}
                enabled={enabled}
                isInvalid={isInvalid}
                errorText={errorText}
                readOnlyWhenNoChildren
                testId="invite-entity-picker"
                placeholder="Select destination"
            />
            {!readOnly && <Form.Text className="text-muted">{INVITE_DESTINATION_HINT}</Form.Text>}
        </Form.Group>
    );
};

export default InviteDestinationField;
